import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom-v5-compat";

import Icon from "../app/Atoms/Icons";
import { useJourney } from "./sign_up_journeys";
import Loading from "./Loading";
import { Progress } from "./types";
const TOTAL_MINUTES = 5;

const PercentageComplete = ({ progress }: { progress: Progress }) => {
  const { t } = useTranslation();
  const { currentStep, totalSteps } = progress;
  const minutesPerPage = TOTAL_MINUTES / totalSteps;
  const percentageComplete = Math.max(
    (currentStep / totalSteps) * 100,
    3
  ).toFixed(0);
  const minutesRemaining = Math.floor(
    (totalSteps - currentStep) * minutesPerPage
  );
  return (
    <div className="text-xs text-right">
      {t("common.percentageComplete", { percentageComplete })} -{" "}
      {t("common.minutesRemaining", { minutesRemaining })}
    </div>
  );
};

export const SingleColumnPage = ({
  progress,
  content,
}: {
  progress: Progress;
  content: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const { loadingState } = useJourney();
  const navigate = useNavigate();
  return (
    <div className="sm:flex items-stretch min-h-screen">
      <div className="flex-1 items-stretch  bg-white p-32 space-y-16">
        <div className="flex justify-between">
          <div className="text-xs align-middle">
            <a
              onClick={() => {
                navigate(-1);
              }}
            >
              <Icon
                icon="chevronLeft"
                color={"black"}
                size="16"
                className={undefined}
              />
              {t("common.back")}
            </a>
          </div>
          <PercentageComplete progress={progress} />
        </div>
        <div className="flex justify-center">
          <Loading loadingState={loadingState}>
            <div className="flex-1 px-24">{content} </div>
          </Loading>
        </div>
      </div>
    </div>
  );
};
export const TwoColumnPage = ({
  progress,
  left,
  right,
}: {
  progress: Progress;
  left: React.ReactNode;
  right: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const { loadingState } = useJourney();
  const navigate = useNavigate();

  return (
    <div className="sm:flex items-stretch min-h-screen">
      <div className="flex-1 items-stretch bg-gradient-to-br from-posboss-brand-gradient-blue to-paperless-brand-gradient-green p-32 space-y-16">
        <div className="text-xs align-middle">
          <a
            onClick={() => {
              navigate(-1);
            }}
          >
            <Icon
              icon="chevronLeft"
              color={"black"}
              size="16"
              className={undefined}
            />
            {t("common.back")}
          </a>
        </div>
        <div className="flex justify-center ">
          <div className="flex-1 px-24">{left} </div>
        </div>
      </div>
      <div className="flex-1  bg-white p-32 space-y-16">
        <PercentageComplete progress={progress} />
        <div className="flex justify-center ">
          <Loading loadingState={loadingState}>
            <div className="flex-1">{right} </div>
          </Loading>
        </div>
      </div>
    </div>
  );
};

export const ContentBlock = ({
  left,
  right,
  subTitle,
  content,
}: {
  left?: boolean;
  right?: boolean;
  subTitle?: React.ReactNode;
  content?: React.ReactNode[];
}) => {
  return (
    <div className={classNames("flex", { "justify-end": right })}>
      <div
        className={classNames("space-y-4", {
          "text-left w-4/5": left,
          "text-right w-4/5": right,
        })}
      >
        {subTitle && <h2>{subTitle}</h2>}
        <div className="space-y-24">
          {(content || []).map((c) => (
            <p>{c}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export const InfoPage = ({
  title,
  children,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <div className="space-y-32 max-w-lg mx-auto">
      {title && <h1 className="">{title}</h1>}
      <div className="space-y-48">{children}</div>
    </div>
  );
};
export const Testimonial = ({
  name,
  venue,
  quote,
}: {
  name: string;
  venue: string;
  quote: string;
}) => {
  return (
    <div className="space-y-8 text-xs px-32 sm:px-64 ">
      <div className="italic pr-24 ">
        <span className="text-xl leading-none">" </span>
        <span className="leading-loose">{quote}</span>
        <span className="text-xl leading-none"> " </span>
      </div>
      <div className="text-right">
        - {name} - {venue}
      </div>
    </div>
  );
};
